export default "__VITE_ASSET__BQVY3GLV__"